<template>
  <span id="approve-shipment-rate" v-if="isVisible()">
    <el-button
      id="approve-shipment-rate-button"
      class="button-action-default"
      size="mini"
      type="success"
      plain
      @click="handleApproveRates"
    >{{ $t('customerService.shipment.approveRates') }}
    </el-button>
  </span>
</template>

<script>
import constants from '@/utils/constants';

export default {
  name: 'ApproveShipmentRate',
  props: {
    shipmentId: {
      type: Number,
      default: null
    },
    shipmentStatus: {
      type: Number,
      default: null
    },
    shipmentNonRevenue: {
      type: Boolean,
      default: null
    }
  },
  methods: {
    async handleApproveRates() {
      const confirm = await this.$confirm(this.$t('customerService.shipment.approveShipmentRatesConfirmation'), { confirmButtonText: this.$t('common.yes'), dangerouslyUseHTMLString: true }).catch(() => {});
      if (confirm) {
        const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
        const response = await this.$store.dispatch('shipment/approveRates', this.shipmentId).catch(() => {});
        if (response) {
          this.$message.success(response);
        }
        this.$store.dispatch('shipment/searchRatings', {
          shipmentId: this.shipmentId,
          page: constants.TABLES.DEFAULT_PAGE,
          rows: constants.TABLES.DEFAULT_LIMIT,
          pageResults: true
        });
        this.$store.dispatch('shipment/searchHeader', this.shipmentId);
        loading.close();
      }
    },
    isVisible() {
      const hasShipmentStatusErrorOrMaster = this.shipmentStatus === constants.SHIPMENT.STATUS[3].value || this.shipmentStatus === constants.SHIPMENT.STATUS[4].value;
      const hasPermission = this.$can(this.permissions.BILLING.EDIT_RATING);
      return hasShipmentStatusErrorOrMaster && hasPermission && !this.shipmentNonRevenue;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#approve-shipment-rate {
  float: right;
}
</style>
